<!-- 成功案例 -->
<template>
	<div class="successCase-container">
		<div class="title">羿畅为高速公路养护决策提供数据支持</div>

		<!--适配移动端-->
		<div class="small-title">
			<div class="article-title">高速公路养护决策平台解决方案</div>
			<div class="article-info">帮助养护单位降本增效，科学养护</div>
			<div class="line">
				<div class="block"></div>
			</div>
		</div>
		<div class="half-container fifth-bg">
			<div class="article-container">
				<div class="article-title">道路AI智能巡检系统解决方案</div>
				<div class="article-info">智能巡检，安全高效</div>
				<div class="article-line">
					<div class="article-short"></div>
				</div>
				<div class="article-ul">
					<div class="article-li" v-for="(item,index) in AIData" :key="index">
						<img class="li-img" src="@/assets/image/choiceYC/successCase/checked.png" alt />
						<span class="li-text">{{ item.label }}</span>
					</div>
				</div>
				<div class="article-bottom">
					<el-button class="btn" size="small" type="primary" @click="handleDetail('roadAIMaintain')">
						了解详情
					</el-button>
				</div>
				<div class="article-line"></div>
				<div class="article-foot">
					<div class="foot-btn" v-for="(item,index) in highFifData" :key="index">{{ item.label }}</div>
				</div>
			</div>
		</div>
		
		<!--适配移动端-->
		<div class="small-title">
			<div class="article-title">公路安全设施监测感知报警系统解决方案</div>
			<div class="article-info">智能化、精准化，为公路交通安全保驾护航</div>
			<div class="line">
				<div class="block"></div>
			</div>
		</div>
		<div class="half-container seventh-bg">
			<div class="article-container">
				<div class="article-title">公路安全设施监测感知报警系统解决方案</div>
				<div class="article-info">智能化、精准化，为公路交通安全保驾护航</div>
				<div class="article-line">
					<div class="article-short"></div>
				</div>
				<div class="article-ul">
					<div class="article-li" v-for="(item,index) in highwaySafety" :key="index">
						<img class="li-img" src="@/assets/image/choiceYC/successCase/checked.png" alt />
						<span class="li-text">{{ item.label }}</span>
					</div>
				</div>
				<div class="article-bottom">
					<el-button class="btn" size="small" type="primary" @click="handleDetail('highwaySafety')">
						了解详情
					</el-button>
				</div>
				<div class="article-line"></div>
				<div class="article-foot">
					<div class="foot-btn" v-for="(item,index) in highSecData" :key="index">{{ item.label }}</div>
				</div>
			</div>
		</div>

		<!--适配移动端-->
		<div class="small-title">
			<div class="article-title">高速公路视频监控AI智能监测平台解决方案</div>
			<div class="article-info">整合高清视频监控、AI算法和数据分析技术</div>
			<div class="line">
				<div class="block"></div>
			</div>
		</div>
		<div class="half-container eighth-bg">
			<div class="article-container">
				<div class="article-title">高速公路视频监控AI智能监测平台解决方案</div>
				<div class="article-info">整合高清视频监控、AI算法和数据分析技术</div>
				<div class="article-line">
					<div class="article-short"></div>
				</div>
				<div class="article-ul">
					<div class="article-li" v-for="(item,index) in surveillanceAI" :key="index">
						<img class="li-img" src="@/assets/image/choiceYC/successCase/checked.png" alt />
						<span class="li-text">{{ item.label }}</span>
					</div>
				</div>
				<div class="article-bottom">
					<el-button class="btn" size="small" type="primary" @click="handleDetail('surveillanceAI')">
						了解详情
					</el-button>
				</div>
				<div class="article-line"></div>
				<div class="article-foot">
					<div class="foot-btn" v-for="(item,index) in highFouData" :key="index">{{ item.label }}</div>
				</div>
			</div>
		</div>

		<!--适配移动端-->
		<div class="small-title">
			<div class="article-title">高速公路养护决策平台解决方案</div>
			<div class="article-info">帮助养护单位降本增效，科学养护</div>
			<div class="line">
				<div class="block"></div>
			</div>
		</div>
		<div class="half-container first-bg">
			<div class="article-container">
				<div class="article-title">高速公路养护决策平台解决方案</div>
				<div class="article-info">帮助养护单位降本增效，科学养护</div>
				<div class="article-line">
					<div class="article-short"></div>
				</div>
				<div class="article-ul">
					<div class="article-li" v-for="(item,index) in decisionData" :key="index">
						<img class="li-img" src="@/assets/image/choiceYC/successCase/checked.png" alt />
						<span class="li-text">{{ item.label }}</span>
					</div>
				</div>
				<div class="article-bottom">
					<el-button class="btn" size="small" type="primary" @click="handleDetail('freewayMaintain')">
						了解详情
					</el-button>
				</div>
				<div class="article-line"></div>
				<div class="article-foot">
					<div class="foot-btn" v-for="(item,index) in highData" :key="index">{{ item.label }}</div>
				</div>
			</div>
		</div>

		<!--适配移动端-->
		<div class="small-title">
			<div class="article-title">高速公路养护决策分析系统解决方案</div>
			<div class="article-info">技术赋能，为高速提供安全保障</div>
			<div class="line">
				<div class="block"></div>
			</div>
		</div>
		<div class="half-container second-bg">
			<div class="article-container">
				<div class="article-title">高速公路养护决策分析系统解决方案</div>
				<div class="article-info">技术赋能，为高速提供安全保障</div>
				<div class="article-line">
					<div class="article-short"></div>
				</div>
				<div class="article-ul">
					<div class="article-li" v-for="(item,index) in analysisData" :key="index">
						<img class="li-img" src="@/assets/image/choiceYC/successCase/checked.png" alt />
						<span class="li-text">{{ item.label }}</span>
					</div>
				</div>
				<div class="article-bottom">
					<el-button class="btn" size="small" type="primary" @click="handleDetail('freewayDecision')">
						了解详情
					</el-button>
				</div>
				<div class="article-line"></div>
				<div class="article-foot">
					<div class="foot-btn" v-for="(item,index) in highSecData" :key="index">{{ item.label }}</div>
				</div>
			</div>
		</div>

		<!--适配移动端-->
		<div class="small-title">
			<div class="article-title">高速公路养护决策平台解决方案</div>
			<div class="article-info">帮助养护单位降本增效，科学养护</div>
			<div class="line">
				<div class="block"></div>
			</div>
		</div>
		<div class="half-container third-bg">
			<div class="article-container">
				<div class="article-title">普通公路养护管理系统解决方案</div>
				<div class="article-info">一站式解决养护流程化痛点</div>
				<div class="article-line">
					<div class="article-short"></div>
				</div>
				<div class="article-ul">
					<div class="article-li" v-for="(item,index) in patrolData" :key="index">
						<img class="li-img" src="@/assets/image/choiceYC/successCase/checked-white.png" alt />
						<span class="li-text">{{ item.label }}</span>
					</div>
				</div>
				<div class="article-bottom">
					<el-button class="btn" size="small" type="primary" @click="handleDetail('normalRoadMaintain')">
						了解详情
					</el-button>
				</div>
				<div class="article-line"></div>
				<div class="article-foot">
					<div class="foot-btn" v-for="(item,index) in highThiData" :key="index">{{ item.label }}</div>
				</div>
			</div>
		</div>


		<!--适配移动端-->
		<div class="small-title">
			<div class="article-title">高速公路养护决策平台解决方案</div>
			<div class="article-info">帮助养护单位降本增效，科学养护</div>
			<div class="line">
				<div class="block"></div>
			</div>
		</div>
		<div class="half-container fourth-bg">
			<div class="article-container">
				<div class="article-title">农村公路大数据云平台解决方案</div>
				<div class="article-info">助力“四好农村公路”高质量发展</div>
				<div class="article-line">
					<div class="article-short"></div>
				</div>
				<div class="article-ul">
					<div class="article-li" v-for="(item,index) in bigData" :key="index">
						<img class="li-img" src="@/assets/image/choiceYC/successCase/checked.png" alt />
						<span class="li-text">{{ item.label }}</span>
					</div>
				</div>
				<div class="article-bottom">
					<el-button class="btn" size="small" type="primary" @click="handleDetail('ruralRoadBigData')">
						了解详情
					</el-button>
				</div>
				<div class="article-line"></div>
				<div class="article-foot">
					<div class="foot-btn" v-for="(item,index) in highFouData" :key="index">{{ item.label }}</div>
				</div>
			</div>
		</div>

		<!--适配移动端-->
		<div class="small-title">
			<div class="article-title">高速公路养护决策平台解决方案</div>
			<div class="article-info">帮助养护单位降本增效，科学养护</div>
			<div class="line">
				<div class="block"></div>
			</div>
		</div>
		<div class="half-container sixth-bg">
			<div class="article-container">
				<div class="article-title">自动化检测服务解决方案</div>
				<div class="article-info">自动化检测，科学制定养护工程实施计划</div>
				<div class="article-line">
					<div class="article-short"></div>
				</div>
				<div class="article-ul">
					<div class="article-li" v-for="(item,index) in automaticData" :key="index">
						<img class="li-img" src="@/assets/image/choiceYC/successCase/checked-white.png" alt />
						<span class="li-text">{{ item.label }}</span>
					</div>
				</div>
				<div class="article-bottom">
					<el-button class="btn" size="small" type="primary" @click="handleDetail('ruralRoadAutoDetection')">
						了解详情
					</el-button>
				</div>
				<div class="article-line"></div>
				<div class="article-foot">
					<div class="foot-btn" v-for="(item,index) in highSixData" :key="index">{{ item.label }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		name: 'successCase',
		data() {
			return {
				decisionData: [{
						label: '基础数据管理'
					},
					{
						label: '路产路权监管'
					},
					{
						label: '巡查养护管理'
					},
					{
						label: '科学决策分析'
					}
				],
				highData: [{
						label: '内蒙高速'
					},
					{
						label: '天津高速'
					},
					{
						label: '京津高速'
					},
					{
						label: '天津交科院'
					}
				],
				analysisData: [{
						label: '基础数据管理'
					},
					{
						label: '技术状况评定'
					},
					{
						label: '养护预测分析'
					},
					{
						label: '养护决策评估'
					}
				],
				highSecData: [{
						label: '且末高速'
					},
					{
						label: '潜江交通'
					},
					{
						label: '河北高速'
					},
					{
						label: '陕西高速'
					},
					{
						label: '天津高速'
					}
				],
				patrolData: [{
						label: '建立养护管理办法'
					},
					{
						label: '强化督查考核机制'
					},
					{
						label: '构建科学养护格局'
					},
					{
						label: '赋能养护降本增效'
					}
				],
				highThiData: [{
						label: '远安交通'
					},
					{
						label: '三河交通'
					},
					{
						label: '香河交通'
					},
					{
						label: '咸安交通'
					},
					{
						label: '沁阳交通'
					}
				],
				bigData: [{
						label: '建设好'
					},
					{
						label: '管理好'
					},
					{
						label: '养护好'
					},
					{
						label: '运营好'
					}
				],
				highFouData: [{
						label: '南漳交通'
					},
					{
						label: '金川交通'
					},
					{
						label: '邱县交通'
					},
					{
						label: '馆陶交通'
					},
					{
						label: '肃宁交通'
					}
				],
				AIData: [{
						label: '设置巡检路线'
					},
					{
						label: '实时病害识别'
					},
					{
						label: '后台自动筛选'
					},
					{
						label: '养护工程流转'
					}
				],
				highFifData: [{
						label: '孝昌交通'
					},
					{
						label: '崇阳交通'
					},
					{
						label: '钟祥交通'
					},
					{
						label: '房县交通'
					}
				],
				automaticData: [{
						label: '检测政策要求'
					},
					{
						label: '检测评定指标'
					},
					{
						label: '输出报表报告'
					},
					{
						label: '制定养护计划'
					}
				],
				highSixData: [{
						label: '古浪交通'
					},
					{
						label: '民勤交通'
					},
					{
						label: '张家川交通'
					},
					{
						label: '庄浪交通'
					},
					{
						label: '甘州区交通'
					}
				],
				highwaySafety: [{
						label: '安全设施状态监测'
					},
					{
						label: '交通事件检测'
					},
					{
						label: '预警报警'
					},
					{
						label: '数据分析与可视化'
					}
				],
				surveillanceAI: [{
						label: '实时监控'
					},
					{
						label: '事件检测'
					},
					{
						label: '车牌识别'
					},
					{
						label: '行为分析'
					},
					{
						label: '预警系统'
					},
					{
						label: '数据分析'
					}
				]
			}
		},
		methods: {
			//查看详情
			handleDetail(page) {
				//跳转到解决方案页面
				this.$router.replace({
					name: 'prescription'
				})
				this.$nextTick(() => {
					this.$bus.$emit('selectSystem', page)
				})
			}
		}
	}
</script>

<style lang='scss' scoped>
	.successCase-container {
		margin-top: 50px;
		height: 100%;
		width: 100%;

		.title {
			width: 100%;
			height: 80px;
			font-size: 40px;
			text-align: center;
		}

		.small-title {
			display: none;
		}

		.half-container {
			height: 620px;

			.article-container {
				width: 550px;
				padding-top: 120px;

				.article-title {
					height: 36px;
					font-size: 36px;
				}

				.article-info {
					margin-top: 20px;
					margin-bottom: 32px;
					height: 20px;
					font-size: 20px;
				}

				.article-line {
					width: 100%;
					height: 1px;
					border-bottom: 1px solid #dcecff;

					.article-short {
						width: 70px;
						height: 4px;
						background: #0079fe;
						position: relative;
						top: -2px;
					}
				}

				.article-ul {
					display: flex;
					flex-wrap: wrap;
					width: 400px;
					padding: 32px 0;

					.article-li {
						width: 50%;
						display: flex;
						align-items: center;
						line-height: 48px;

						.li-img {
							width: 22px;
						}

						.li-text {
							margin-left: 16px;
						}
					}
				}

				.article-bottom {
					margin-bottom: 32px;

					::v-deep .el-button--primary {
						background-color: #0079fe;
						border-color: #0079fe;
						width: 120px;
					}

					::v-deep .el-button--primary:hover {
						background-color: #66b1ff;
						border-color: #66b1ff;
					}
				}

				.article-foot {
					display: flex;
					flex-wrap: wrap;
					padding-top: 16px;

					.foot-btn {
						width: 110px;
						padding: 12px 0;
						text-align: center;
						background: linear-gradient(180deg,
								#f3f9ff 0%,
								#ffffff 100%);
						box-shadow: 0 3px 6px 1px rgba(52, 128, 213, 0.18);
						border-radius: 4px;
						margin-right: 16px;
						cursor: pointer;
					}

					.foot-btn:hover {
						opacity: 0.6;
					}
				}
			}
		}

		.first-bg {
			width: 1300px;
			margin: 0 auto;
			background-image: url("@/assets/image/choiceYC/successCase/bg_01.png");
			background-repeat: no-repeat;
			background-position: 120% 0;
			background-size: contain;

		}

		.second-bg {
			width: 100%;
			margin: 0 auto;
			background-image: url("@/assets/image/choiceYC/successCase/bg_02.png");
			background-repeat: no-repeat;
			background-position: 100% 0;
			background-size: 100% 100%;
			position: relative;

			.article-container {
				width: 50%;
				height: 500px;
				position: absolute;
				right: 0;
				padding-left: 10%;
				background-image: url("@/assets/image/choiceYC/successCase/bg_white.png");
				background-repeat: no-repeat;
				background-position: 100% 0;
				background-size: 100% 100%;
			}
		}

		.third-bg {
			width: 100%;
			margin: 0 auto;
			background-image: url("@/assets/image/choiceYC/successCase/bg_03.png");
			background-repeat: no-repeat;
			background-position: 100% 0;
			background-size: 100% 100%;
			position: relative;

			.article-container {
				width: 650px;
				height: 500px;
				padding-left: calc((100% - 1300px) / 2);
				position: absolute;
				left: 0;
				background-image: url("@/assets/image/choiceYC/successCase/bg_blue.png");
				background-repeat: no-repeat;
				background-position: 100% 0;
				background-size: 100% 100%;

				.article-title {
					color: #ffffff;
				}

				.article-info {
					color: #ffffff;
				}

				.article-ul {
					color: #ffffff;
				}

				.article-line {
					.article-short {
						background: #ffffff;
					}
				}
			}
		}

		.fourth-bg {
			width: 1300px;
			margin: 0 auto;
			background-image: url("@/assets/image/choiceYC/successCase/bg_04.png");
			background-repeat: no-repeat;
			background-position: -20% 0;
			background-size: 60%;
			position: relative;

			.article-container {
				width: 55%;
				height: 500px;
				position: absolute;
				right: -5%;
			}
		}

		.fifth-bg {
			width: 100%;
			margin: 0 auto;
			background-image: url("@/assets/image/choiceYC/successCase/bg_05.png");
			background-repeat: no-repeat;
			background-position: 100% 0;
			background-size: 100% 100%;
			position: relative;

			.article-container {
				width: 650px;
				height: 500px;
				padding-left: calc((100% - 1300px) / 2);
				position: absolute;
				left: 0;
				background-image: url("@/assets/image/choiceYC/successCase/bg_white_l.png");
				background-repeat: no-repeat;
				background-position: 100% 0;
				background-size: 100% 100%;
			}
		}

		.sixth-bg {
			width: 100%;
			margin: 0 auto;
			background-image: url("@/assets/image/choiceYC/successCase/bg_06.png");
			background-repeat: no-repeat;
			background-position: 100% 0;
			background-size: 100% 100%;
			position: relative;

			.article-container {
				width: 50%;
				height: 500px;
				position: absolute;
				right: 0;
				padding-left: 10%;
				background-image: url("@/assets/image/choiceYC/successCase/bg_blue_r.png");
				background-repeat: no-repeat;
				background-position: 100% 0;
				background-size: 100% 100%;

				.article-title {
					color: #ffffff;
				}

				.article-info {
					color: #ffffff;
				}

				.article-ul {
					color: #ffffff;
				}

				.article-line {
					width: 75%;

					.article-short {
						background: #ffffff;
					}
				}
			}
		}

		.seventh-bg {
			width: 100%;
			margin: 0 auto;
			background-image: url("@/assets/image/choiceYC/successCase/bg_07.jpg");
			background-repeat: no-repeat;
			background-position: 100% 0;
			background-size: 100% 100%;
			position: relative;

			.article-container {
				width: 50%;
				height: 500px;
				position: absolute;
				right: 0;
				padding-left: 10%;
				background-image: url("@/assets/image/choiceYC/successCase/bg_white.png");
				background-repeat: no-repeat;
				background-position: 100% 0;
				background-size: 100% 100%;
			}
		}

		.eighth-bg {
			width: 100%;
			margin: 0 auto;
			background-image: url("@/assets/image/choiceYC/successCase/bg_08.jpg");
			background-repeat: no-repeat;
			background-position: 100% 0;
			background-size: 100% 100%;
			position: relative;
			
			.article-container {
				width: 50%;
				height: 500px;
				position: absolute;
				right: 0;
				padding-left: 10%;
				background-image: url("@/assets/image/choiceYC/successCase/bg_white.png");
				background-repeat: no-repeat;
				background-position: 100% 0;
				background-size: 100% 100%;
			}
		}
	}

	@import "./style.scss";
</style>